












import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

@Component({
  components: {
    }
})
export default class Node extends Vue 
{
    @Prop() node! : any;
    @Prop() selectedNode! : any;
    @Prop() hierarchy! : number;

    mounted(){
        // 開いたときに親要素にIDを送る
        this.$emit("setChildren", this.node.id);        
    }

    select(id , hierarchy){
        this.$emit("select" , id , hierarchy);
    }
    
    private get userConfigBackgroundColor(){
        var style = {};
        if(this.node.id == this.selectedNode.id && this.node.hierarchy == this.selectedNode.hierarchy){
            var rgb = this.$store.getters.userConfigColors.buttonColorRgb;
            style = {
                position: "relative",
                display: "table",
                width: "calc(100% + " + (16 * this.hierarchy) + "px)",
                height: "25px",
                left : -16 * this.hierarchy + "px",
                backgroundColor : "rgba( " + rgb.r + " , " + rgb.g + " , " + rgb.b + " , 0.5 )",
                pointerEvents: "none"
            }
        }
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
